import React from 'react';

import AlertWrapper from '../AlertWrapper';
import AlertLeftBlock from '../AlertLeftBlock';
import AlertMiddleBlock from '../AlertMiddleBlock';
import AlertRightBlock from '../AlertRightBlock';

export default function AlertItem(props) {
  return (
    <AlertWrapper {...props}>
      <header>
        <AlertLeftBlock type="header" {...props} />
        <AlertMiddleBlock type="header" {...props} />
        <AlertRightBlock type="header" {...props} />
      </header>
      <section>
        <AlertLeftBlock type="content" {...props} />
        <AlertMiddleBlock type="content" {...props} />
        <AlertRightBlock type="content" {...props} />
      </section>
    </AlertWrapper>
  );
}
